import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Reveal } from "../components/Reveal";
import { SectionHead } from "../components/SectionHead";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const Contact = ({ t }) => {
  const [form, setForm] = useState({ name: "", org: "", email: "", message: "" });
  const [sending, setSending] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await axios.post(`${API}/leads`, form);
      toast.success(t.ok);
      setForm({ name: "", org: "", email: "", message: "" });
    } catch {
      toast.error(t.err);
    } finally {
      setSending(false);
    }
  };

  const field = "w-full bg-transparent border border-[#272A2E] px-5 py-4 text-sm font-mono text-white placeholder:text-[#4A4F58] focus:border-[#FF2A00] focus:outline-none transition-colors duration-300";

  return (
    <section id="contact" data-testid="section-contact" className="py-32 md:py-48">
      <div className="max-w-[1600px] mx-auto px-6 md:px-10 grid grid-cols-12 gap-10">
        <div className="col-span-12 lg:col-span-5">
          <Reveal><SectionHead index={t.index} title={t.title} lead={t.lead} /></Reveal>
        </div>
        <Reveal delay={0.1} className="col-span-12 lg:col-span-7">
          <form data-testid="contact-form" onSubmit={submit} className="grid sm:grid-cols-2 gap-4">
            <input required data-testid="contact-name" placeholder={t.name} value={form.name} onChange={set("name")} className={field} />
            <input required data-testid="contact-org" placeholder={t.org} value={form.org} onChange={set("org")} className={field} />
            <input required type="email" data-testid="contact-email" placeholder={t.email} value={form.email} onChange={set("email")} className={`${field} sm:col-span-2`} />
            <textarea required rows={5} data-testid="contact-message" placeholder={t.message} value={form.message} onChange={set("message")} className={`${field} sm:col-span-2 resize-none`} />
            <button type="submit" disabled={sending} data-testid="contact-submit"
              className="sm:col-span-2 mt-2 bg-[#FF2A00] text-black font-mono text-sm tracking-[0.2em] uppercase py-5 hover:bg-white transition-colors duration-300 disabled:opacity-50">
              {sending ? t.sending : t.submit}
            </button>
          </form>
        </Reveal>
      </div>
    </section>
  );
};
